import type { OrgSettings } from '@/hooks/useOrgSettings';

/**
 * Chiavi di pricing sovrascrivibili per-preventivo. Speculari a organizations.settings.
 * Un preventivo puo' salvare override solo su alcune (le altre ereditano dall'org).
 */
export const ESTIMATE_PRICING_KEYS = [
  'markup_materials_pct',
  'markup_labor_pct',
  'markup_finish_pct',
  'overhead_pct',
  'safety_pct',
  'transport_flat',
  'disposal_flat',
  'disposal_materials_pct',
  'iva_pct',
  'default_customer_discount_pct',
] as const;

export type EstimatePricingKey = (typeof ESTIMATE_PRICING_KEYS)[number];

export type EstimatePricingOverrides = Partial<Record<EstimatePricingKey, number>>;

/**
 * Fonde i settings dell'organizzazione con gli override del preventivo:
 * ogni chiave numerica valorizzata nell'override VINCE su quella org; le chiavi
 * assenti/null ereditano dall'org. Il risultato e' passato ad `applyPricing`
 * come se fosse un settings org "effettivo", cosi' card, barra riepilogo e PDF
 * usano tutti la STESSA pipeline con gli override applicati.
 */
export function mergeEstimatePricing(
  org: OrgSettings | null | undefined,
  overrides: EstimatePricingOverrides | null | undefined,
): OrgSettings {
  const base: OrgSettings = { ...(org ?? {}) } as OrgSettings;
  if (!overrides) return base;
  for (const key of ESTIMATE_PRICING_KEYS) {
    const v = overrides[key];
    if (v != null && Number.isFinite(Number(v))) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (base as any)[key] = Number(v);
    }
  }
  return base;
}
